/// <reference path="modules.d.ts" />
import 'reflect-metadata'
import 'src/core/boot-common'
import React from 'react'
import ReactDOM from 'react-dom'
import {BrowserRouter} from 'react-router-dom'
import {createBrowserHistory} from 'history'
import App from './app'
import './core/assets/site.less'
import './assets/theme.less'
import './assets/custom.scss'
import {initialize as initializeInversify} from './inversify.config'
import 'src/core/utils/linq'
import {I18nextProvider} from 'react-i18next'
import i18n from './i18n'
import {Provider as ReduxProvider} from 'react-redux'
import {AppConfig, ApplicationState, initialize} from './stores/reducers'
import configureStore from './configureStore'
import SecureContent from 'src/core/services/authentication'
import CacheContent from 'src/core/services/cache.service'
import Telemetry from 'src/telemetry'
import NotificationContent from "src/consumer/notificationContent"
import ShellDisclaimer from 'src/core/ui/shell-disclaimer'
import UserProfileSecureShell from 'src/components/user-profile'
import ShellNotification from 'src/components/systemNotifications/shell-notification'


const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href')
const history = createBrowserHistory({ basename: baseUrl as string })
const rootElement = document.getElementById('root')

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = (window as any).initialReduxState as ApplicationState
const store = configureStore(history, initialState)

function renderApp(config?: AppConfig) {
    // This code starts up the React app when it runs in a browser. It sets up the routing configuration
    // and injects the app into a DOM element.
    ReactDOM.render(
        <BrowserRouter basename={baseUrl as string}>
            <ReduxProvider store={store}>
                <I18nextProvider i18n={i18n}>
                    <SecureContent
                        config={{
                            authority: config!.identityServerUrl,
                            redirectUri: config!.serviceUrl,
                            silentRedirectUri: `${config!.serviceUrl}/silentrefresh.html`,
                            resource: config!.scopes,
                            clientId: config!.clientId,
                            passthrough: config!.passthrough
                        }}
                        onAuthentication={() => {
                            window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search)
                        }}>

                        <CacheContent scope="pmo">
                            <UserProfileSecureShell serviceUrl={config!.serviceUrl}>
                                <ShellNotification>
                                    <NotificationContent>                                    
                                        <ShellDisclaimer>
                                            <Telemetry aiRoleName={config!.aiRoleName} instrumentationKey={config!.aiInstrumentationKey}>
                                                <App />
                                            </Telemetry>
                                        </ShellDisclaimer>                                   
                                    </NotificationContent>
                                </ShellNotification>
                            </UserProfileSecureShell >
                        </CacheContent>
                    </SecureContent>
                </I18nextProvider>
            </ReduxProvider>
        </BrowserRouter >,
        rootElement)
}

if (initialState) {
    initializeInversify(initialState)
    renderApp(initialState.config)
} else {
    (store.dispatch(initialize() as any)() as Promise<void>).then(() => {
        const state = store.getState()
        initializeInversify(state)
        renderApp(state ? state.config : undefined)
    })
}

//registerServiceWorker();